import React from "react";
import { Flex } from "@indeed/ifl-components";
import { ContributorGroup } from "./contributorGroup";
import { SocialsRow } from "./articleHero";
import { extractContributors, parseContributorTitles } from "helpers/utils";
import type { Contributor } from "types/globals";

export interface ArticleFooterProps {
  authorName: string;
  articleTitle: string;
  articleUrl: string;
  contributorList: Contributor[];
}

const ArticleFooter: React.FC<ArticleFooterProps> = ({
  articleTitle,
  articleUrl,
  authorName,
  contributorList,
}) => {
  const contributorObject = extractContributors(contributorList);

  return (
    <>
      <SocialsRow
        author={authorName}
        title={articleTitle}
        url={articleUrl}
        sx={{
          alignItems: "flex-end",
        }}
      />
      {/* Spacer*/}
      <Flex
        sx={{
          width: "100%",
          justifyContent: "center",
          my: ["16px", null, "20px", null],
          svg: {
            mx: 2,
          },
        }}
      />
      {/* Contributor Credit */}
      <Flex
        sx={{
          width: "100%",
          justifyContent: "space-between",
          flexDirection: "column",
          mb: 5,
        }}
      >
        {Object.entries(contributorObject).map(([key, contributorArr]) => {
          if (!contributorArr.length) {
            return null;
          }
          return (
            <ContributorGroup
              key={key}
              contributorList={contributorArr}
              label={parseContributorTitles(key, contributorArr)}
              sx={{ mt: [3, null, null, 0] }}
            />
          );
        })}
      </Flex>
    </>
  );
};

export default ArticleFooter;
